export default __webpack_public_path__ + "static/media/logo-x.fcbd2cbe.svg";